import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { AboutEditor } from "@/components/admin/AboutEditor";

export const Route = createFileRoute("/admin/about")({
  component: AboutPage,
  head: () => ({
    meta: [
      { title: "About — Admin" },
      { name: "description", content: "Manage about page content" },
    ],
  }),
});

function AboutPage() {
  return (
    <AdminLayout>
      <AboutEditor />
    </AdminLayout>
  );
}
